import React from 'react';
import {Container, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav } from 'reactstrap';
import profilePic from '../down.png';

class TopBar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <Navbar color="dark" dark expand="md">
        <Container>
          <NavbarBrand href="/">
            <img src={profilePic} className="profile-pic" alt="Faiyaz Sundrani"/>
            <span>Faiyaz Sundrani</span>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle}/>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              
              {/* <NavItem>
                <NavLink href="/profile/">Profile</NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink href="/resume/">Resume</NavLink>
              </NavItem> */}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default TopBar;